import { FC, useContext, useEffect, useState } from "react";
import { Button, CustomLink, Layout, Result, Select } from "../../components";
import logo from "../../assets/logo.svg";
import { useNavigate } from "react-router-dom";
import { Context } from "../..";
import { Response, Service } from "../../types";
import $api from "../../http";
import config from "../../config";
import { AxiosResponse } from "axios";
import { observer } from "mobx-react";

const DeleteService: FC<{ title: string }> = observer(({ title }) => {
  const navigate = useNavigate();
  const { store } = useContext(Context);
  useEffect(() => {
    if (!store.isAuth) return navigate("/");
    if (store.user.type !== "admin") return navigate(`/${store.user.type}`);
  }, [navigate, store.isAuth, store.user.type]);

  const [services, setServices] = useState<Service[]>();
  const [selectedService, setSelectedService] = useState<string>();

  const [result, setResult] = useState<Response>({} as Response);
  const sendData = () => {
    if (!selectedService || selectedService === "0") return setResult({ status: "error", message: "Выберите услугу" });
    $api.delete(`${config.API}/service/delete`, { data: { id: selectedService } }).then(({ data }: AxiosResponse<Response>) => {
      setResult({ ...data });
    });
  };

  useEffect(() => {
    $api.get(`${config.API}/service/all`).then(({ data }) => setServices(data.data));
  }, []);

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={120} height={120} style={{ marginBottom: 50 }} />
      <CustomLink to={"/admin"}>{"<-"} Админ панель</CustomLink>

      <p>Выберите услугу</p>
      <Select defaultValue={"0"} onChange={({ target }) => setSelectedService(target.value)}>
        <option value={"0"} disabled>
          Выберите услугу
        </option>
        {services ? (
          services.map((e: Service) => (
            <option value={e._id} key={e._id}>
              {e.name} - {e.price}р - {e.sale ? "скидка" : "без скидки"}
            </option>
          ))
        ) : (
          <option>Услуги не найдены</option>
        )}
      </Select>

      {selectedService && (
        <>
          <Button onClick={sendData}>Выполнить</Button>
          <Result {...result} />
        </>
      )}
    </Layout>
  );
});

export default DeleteService;
